import React, { FC } from "react";
import { List, ListItem, Popover, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { POPUPS } from "../../constants";
import StyledPaper from "../Common/StyledPaper";
import { Hyperlink, RxStrategy } from "../../typescript/interfaces/data";

const useStyles = makeStyles(() => ({
  container: {
    padding: "0px 8px",

    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  list: {
    width: "100%",
  },
  title: {
    paddingBottom: 0,

    "& > li": {
      paddingBottom: "inherit",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
    "& > p": {
      fontWeight: 700,
    },
  },
  item: {
    minHeight: "24px",
    padding: "0px 4px",
  },
  titleText: {
    fontWeight: 600,
    fontSize: "1rem",
  },
  text: {
    padding: "0px 4px",
  },
}));

type IconLinksType = {
  popupTitle: string;
  isOpen: boolean;
  anchorEl: any;
  links: Array<any>;
  closePopover: () => any;
};

const IconLinks: FC<IconLinksType> = ({ popupTitle, anchorEl, isOpen, closePopover, links }) => {
  const classes = useStyles();

  return (
    <Popover
      id={popupTitle}
      open={isOpen}
      anchorEl={anchorEl}
      onClose={closePopover}
      anchorOrigin={POPUPS.ANCHOR_ORIGIN}
      transformOrigin={POPUPS.TRANSFORM_ORIGIN}
    >
      <StyledPaper elevation={7} width="auto" minWidth={POPUPS.LINK_LIST_WIDTHS.rxStrategy}>
        <div className={classes.container}>
          <List className={classes.title}>
            <ListItem disableGutters>
              <Typography variant="body2" className={classes.titleText}>
                {popupTitle}
              </Typography>
            </ListItem>
          </List>
          <List className={classes.list} aria-label="Rx-Strategy Links">
            {links.map((link) => {
              let title: string;
              if ("clinicalDevelopmentNotes" in link) {
                title = link["clinicalDevelopmentNotes"];
              } else {
                title = link.title;
              }

              return (
                <ListItem
                  key={link.id}
                  className={classes.item}
                  disableGutters
                  component="a"
                  href={link.url}
                  target="_blank"
                  button
                >
                  <Typography className={classes.text} variant="body2">
                    {title}
                  </Typography>
                </ListItem>
              );
            })}
          </List>
        </div>
      </StyledPaper>
    </Popover>
  );
};

export default IconLinks;
